import React from 'react';
import cn from 'classnames';

import Icon from 'components/generic/Icon.component';
import { useTheme } from 'providers/Theme.provider';
import fromAnyToTrimmed from 'utils/converters/any/fromAnyToTrimmed.util';
import fromAnyToBool from 'utils/converters/fromAnyToBool.util';
import { concatTag as ct } from 'utils/strings/manipulate.util';

import CN from './ToggleSwitch.module.scss';

const ToggleSwitch = ({
  tag: tagFromProps,
  children,
  onClick,
  selected,
  disabled,
  name,
  size,
  arrow,
  neutral,
  variant,
  ...extra
}) => {
  const tag = fromAnyToTrimmed(tagFromProps);

  const { isDarkMode } = useTheme();

  return (
    <div
      {...extra}
      data-bem="ToggleSwitch"
      data-tag={tag}
      role="button"
      tabIndex={0}
      onClick={onClick}
      className={cn({
        [CN.component]: true,
        [CN.isSelected]: selected,
        [CN.isDisabled]: disabled,
        [CN.darkMode]: isDarkMode,
        [CN.neutral]: neutral, // will be in blue color
        [CN[`${size}Height`]]: size,
        [CN[`${variant}Variant`]]: variant, // If we use variant='mobile', the button displays as a checkbox only on mobile
      })}
    >
      {children}

      <div data-bem="ToggleSwitch__mobile" data-tag={tag} className={CN.mobileBox}>
        <div data-bem="ToggleSwitch__mobile-icon" data-tag={tag} className={CN.mobileIcon}></div>
      </div>

      <div data-bem="ToggleSwitch__name" data-tag={tag} className={CN.name}>
        {name}
      </div>

      {fromAnyToBool(arrow) && <Icon tag={ct('ToggleSwitch__icon', tag)} variant="arrowTriangle" width="xs" />}
    </div>
  );
};

export default ToggleSwitch;
